export default {
  transaction_id: null,
  transaction_status: false,

  transaction_loading: false,
  transaction_result: [],
};
